import { Slider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";

const getHeightFromClass = (classes: string, sizePrefix: string) => {
    if (!classes) return 0;
    const styles = classes
        .split(" ")
        .filter(i => !!i);
    if (!styles.length) return 0;
    const style = styles.find(i => !!i.match(`${sizePrefix}\\d+`));
    if (!style) return 0;
    return style.numberString(false).toInteger();
};

const getUpdatedClassForHeight = (classes: string, sizePrefix: string, removeSizePrefixes: string[], value: number) => {
    return (classes ?? "")
        .split(" ")
        .filter(i => !!i)
        .filter(i => !removeSizePrefixes.find(j => i.startsWith(j)))
        .concat(`${sizePrefix}${value}`)
        .sort()
        .join(" ");
};

interface IFormDesignerComponentPropertiesHeightProps {
    id: string;
    classes: string;
    formFieldMargin: number | string;
    minimum?: number;
    maximum?: number;
    title: string;
    sizePrefix: string;
    onUpdate: (id: string, classes: string) => void;
}

//TODO: Check custom width classes handling
export const FormDesignerComponentPropertiesHeight = ({
    id,
    classes,
    formFieldMargin,
    minimum = 0,
    maximum = 12,
    title,
    sizePrefix,
    onUpdate,
}: IFormDesignerComponentPropertiesHeightProps) => {
    const [height, setHeight] = useState(0);

    useEffect(() => {
        const h = getHeightFromClass(classes, sizePrefix);
        setHeight(Math.min(Math.max(h, minimum), maximum));
    }, [classes]);

    const handleSliderChange = (_event: Event, newValue: number) => {
        setHeight(newValue > maximum ? maximum : newValue);
    };

    const handleSliderChangeCommited = (_event: Event, newValue: number) => {
        onUpdate(id, getUpdatedClassForHeight(classes, sizePrefix, [sizePrefix], newValue > maximum ? maximum : newValue));
    };

    return (
        <FormField title={title} overflow="visible" margin={formFieldMargin}>
            <Slider
                value={height}
                onChange={handleSliderChange}
                onChangeCommitted={handleSliderChangeCommited}
                valueLabelDisplay="auto"
                step={1}
                min={minimum}
                max={maximum}
            />
        </FormField>
    );
};
